import { useQuery, useMutation, useQueryClient } from 'react-query';
import { useFirebase } from 'components/Firebase/index.js';
import { ONE_TO_ONE_PRODUCT } from 'constants/products.js';
import useOrgId from './useOrgId.js';
import useProductDataOutsideRoutes from './useProductDataOutsideRoutes.js';

const useCallSettings = () => {
  const orgId = useOrgId();
  const firebase = useFirebase();
  const queryClient = useQueryClient();
  const { selectedProduct } = useProductDataOutsideRoutes();

  const { data = {}, isSuccess, refetch } = useQuery({
    queryKey: [`/o/${orgId}/call-configurations`],
    enabled: !!orgId && selectedProduct === ONE_TO_ONE_PRODUCT,
  });

  const updateSettings = useMutation(async (updates) => {
    const agent = await firebase.getAgent();
    // If Bambuser bookings just got enabled, provision onsched stuff
    const shouldProvision = !data.enableBookings && updates.enableBookings && updates.bookingSystem === 'native'
      || updates.enableBookings && updates.bookingSystem === 'native' && data.bookingSystem !== 'native';
    if (shouldProvision) {
      await agent.post(`/o/${orgId}/call-bookings-settings`).send({
        provider: 'native-onsched',
      });
    }
    await agent.patch(`/o/${orgId}/call-configurations`).send(updates);
  }, {
    onError: () => {},
    onSuccess: () => {
      queryClient.invalidateQueries([`/o/${orgId}/call-configurations`]);
      refetch();
    },
    onSettled: () => {},
  });

  return { isLoading: !isSuccess, settings: data, updateSettings: updateSettings.mutate };
};

export default useCallSettings;
